import React from 'react'
import styles from './Point.module.css'

const Point = () => {
  return (
    <section className={styles.point_area}>
        <h2>どうして<span>3営業日</span>で納品できるのか</h2>
        <div className={styles.contents}>
            <div className={styles.card}>
                <div className={styles.title}>構成パーツの自動生成化</div>
                <p>
                    当社が制作するランディングページにおいて、制作過程を自動化することにより、制作コストの大幅な削減が実現されております。<br />
                    デザインパーツのコンポーネント化とコーディングパーツの自動化を実現することで、人手を必要とせず、スピーディで高品質なランディングページを制作いたします。
                </p>
                <img src='images/point-img.png' alt='point-img' />
            </div>
            <div className={styles.card}>
                <div className={styles.title}>マーケティング会社独自のノウハウ</div>
                <p>
                    弊社はWebマーケティングの専門会社として、独自のノウハウを活かし、直感的かつ効果的なランディングページを提供いたします。<br />
                    これまでの実績に基づき、効果の見込めない冗長なコンテンツやデザインパーツなどは、あらかじめ選択できる構成パーツから除外し、お客様の貴重なお時間を節約いたします。
                </p>
                <img src='images/point-img-2.png' alt='point-img' />
            </div>
            <div className={styles.card}>
                <div className={styles.title}>やり取りの簡略化</div>
                <p>
                    当サービスにおいては、ご注文から納品までのやり取りを簡略化させていただいております。<br />
                    ランディングページ内の各パーツの選択からテキストに至るまで、全てお客様がヒアリングシートに従って選択いただけるため、余計なお時間をいただくことなく、スムーズな納品が実現できます。
                </p>
                <img src='images/point-img-3.png' alt='point-img' />
            </div>
        </div>
    </section>
  )
}

export default Point